import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  customerCountryFromModel,
  validateCustomerCountryCondition,
  type CustomerCountryState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_COUNTRY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerCountryState>>,
): ConditionType<CustomerCountryState, Condition.CustomerCountry> => ({
  name: CONDITION_NAMES[Condition.CUSTOMER_COUNTRY],
  description(state) {
    return t("Countries: {{count}} selected", { count: state.length });
  },
  Details(props: ConditionTypeDetailsProps<CustomerCountryState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return customerCountryFromModel(model);
  },
  toModel(state) {
    return { type: Condition.CUSTOMER_COUNTRY, countries: state };
  },
  valid(state) {
    return validateCustomerCountryCondition(state).valid;
  },
});
